import api from "@ignite/api"
import { useQuery } from "@tanstack/react-query"

export const useGetMe = () => useQuery([`user`], api.users.getMe)
